import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, Transition as _Transition, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "crb" }
const _hoisted_2 = { class: "crb-head" }
const _hoisted_3 = { class: "crb-title" }
const _hoisted_4 = { class: "crb-sub" }
const _hoisted_5 = {
  key: 0,
  class: "crb-switch",
  "aria-label": "Type de demande"
}
const _hoisted_6 = {
  class: "crb-tabs",
  role: "tablist",
  "aria-label": "Filtrer par statut"
}
const _hoisted_7 = ["aria-selected", "onClick"]
const _hoisted_8 = { class: "crb-toolbar" }
const _hoisted_9 = { class: "crb-search" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "crb-period" }
const _hoisted_12 = ["aria-expanded"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["aria-busy"]
const _hoisted_15 = {
  key: 1,
  class: "crb-state is-error",
  role: "alert"
}
const _hoisted_16 = {
  key: 2,
  class: "crb-state"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  class: "crb-avatar",
  "aria-hidden": "true"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "crb-who" }
const _hoisted_21 = { class: "crb-diff" }
const _hoisted_22 = ["title"]
const _hoisted_23 = { class: "crb-new" }
const _hoisted_24 = {
  key: 0,
  class: "crb-bank"
}
const _hoisted_25 = {
  key: 1,
  class: "crb-bank"
}
const _hoisted_26 = {
  key: 2,
  class: "crb-bank"
}
const _hoisted_27 = ["aria-label"]
const _hoisted_28 = ["title"]
const _hoisted_29 = { class: "crb-when" }
const _hoisted_30 = ["title"]
const _hoisted_31 = {
  key: 4,
  class: "crb-pager",
  "aria-label": "Pagination"
}
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "crb-drawer-head" }
const _hoisted_35 = { id: "crb-drawer-title" }
const _hoisted_36 = { class: "crb-drawer-body" }
const _hoisted_37 = { class: "crb-block" }
const _hoisted_38 = {
  key: 0,
  class: "crb-note"
}
const _hoisted_39 = {
  key: 1,
  class: "crb-note"
}
const _hoisted_40 = {
  key: 2,
  class: "crb-note is-warn"
}
const _hoisted_41 = { class: "crb-compare" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "is-new" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = ["aria-label"]
const _hoisted_46 = {
  key: 3,
  class: "crb-reason"
}
const _hoisted_47 = { class: "crb-block" }
const _hoisted_48 = { class: "crb-checks" }
const _hoisted_49 = {
  key: 0,
  class: "crb-block"
}
const _hoisted_50 = {
  key: 0,
  class: "crb-note is-warn"
}
const _hoisted_51 = { class: "crb-docgrid" }
const _hoisted_52 = ["aria-label", "onClick"]
const _hoisted_53 = ["src", "alt", "onError"]
const _hoisted_54 = {
  key: 1,
  class: "crb-doc-file"
}
const _hoisted_55 = {
  key: 1,
  class: "crb-doc-file"
}
const _hoisted_56 = {
  key: 1,
  class: "crb-block"
}
const _hoisted_57 = ["open"]
const _hoisted_58 = {
  key: 0,
  class: "crb-fix-grid"
}
const _hoisted_59 = ["placeholder"]
const _hoisted_60 = { value: "" }
const _hoisted_61 = ["value"]
const _hoisted_62 = {
  key: 1,
  class: "crb-fix-grid"
}
const _hoisted_63 = ["placeholder"]
const _hoisted_64 = {
  class: "crb-label",
  for: "crb-note"
}
const _hoisted_65 = {
  key: 0,
  class: "crb-req",
  "aria-hidden": "true"
}
const _hoisted_66 = {
  key: 0,
  class: "crb-quick"
}
const _hoisted_67 = ["onClick"]
const _hoisted_68 = {
  key: 1,
  class: "crb-err"
}
const _hoisted_69 = { class: "crb-count" }
const _hoisted_70 = {
  key: 2,
  class: "crb-block"
}
const _hoisted_71 = {
  key: 0,
  class: "crb-reason"
}
const _hoisted_72 = {
  key: 0,
  class: "crb-drawer-foot"
}
const _hoisted_73 = ["disabled"]
const _hoisted_74 = ["disabled"]
const _hoisted_75 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_76 = ["disabled"]
const _hoisted_77 = ["disabled"]
const _hoisted_78 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_79 = {
  key: 1,
  class: "ph ph-check",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DateRangePopover = _resolveComponent("DateRangePopover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[26] || (_cache[26] = _createElementVNode("span", { class: "crb-eyebrow" }, "Demandes clients", -1)),
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.isRib ? "Changements de RIB" : "Changements de téléphone"), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.isRib
            ? "Vérifiez le nouveau RIB et les justificatifs avant de valider : la validation remplace le RIB du magasin et du profil client."
            : "Vérifiez le nouveau numéro avant de valider : la validation remplace le téléphone du magasin et du profil client."), 1)
      ]),
      (_ctx.canRib && _ctx.canPhone)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/rib-requests-list",
              class: _normalizeClass({ 'is-active': _ctx.isRib })
            }, {
              default: _withCtx(() => _cache[27] || (_cache[27] = [
                _createElementVNode("i", {
                  class: "ph ph-bank",
                  "aria-hidden": "true"
                }, null, -1),
                _createTextVNode("RIB", -1)
              ])),
              _: 1,
              __: [27]
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              to: "/phone-requests-list",
              class: _normalizeClass({ 'is-active': !_ctx.isRib })
            }, {
              default: _withCtx(() => _cache[28] || (_cache[28] = [
                _createElementVNode("i", {
                  class: "ph ph-phone",
                  "aria-hidden": "true"
                }, null, -1),
                _createTextVNode("Téléphone", -1)
              ])),
              _: 1,
              __: [28]
            }, 8, ["class"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusTabs, (t) => {
        return (_openBlock(), _createElementBlock("button", {
          key: t.value,
          type: "button",
          role: "tab",
          class: _normalizeClass(["crb-tab", ['tone-' + t.tone, { 'is-active': _ctx.filters.statut === t.value }]]),
          "aria-selected": _ctx.filters.statut === t.value,
          onClick: ($event: any) => (_ctx.setStatut(t.value))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["ph", t.icon]),
            "aria-hidden": "true"
          }, null, 2),
          _createElementVNode("span", null, _toDisplayString(t.label), 1),
          _createElementVNode("b", null, _toDisplayString(t.count), 1)
        ], 10, _hoisted_7))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _cache[29] || (_cache[29] = _createElementVNode("i", {
          class: "ph ph-magnifying-glass",
          "aria-hidden": "true"
        }, null, -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.term) = $event)),
          type: "search",
          placeholder: _ctx.isRib ? 'Client, magasin, RIB, banque…' : 'Client, magasin, numéro…',
          "aria-label": "Rechercher",
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
        }, null, 40, _hoisted_10), [
          [_vModelText, _ctx.filters.term]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["crb-chip-btn", { 'is-set': _ctx.filters.range }]),
          "aria-expanded": _ctx.periodOpen,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.periodOpen = !_ctx.periodOpen))
        }, [
          _cache[30] || (_cache[30] = _createElementVNode("i", {
            class: "ph ph-calendar-blank",
            "aria-hidden": "true"
          }, null, -1)),
          _createTextVNode(_toDisplayString(_ctx.periodLabel) + " ", 1),
          _cache[31] || (_cache[31] = _createElementVNode("i", {
            class: "ph ph-caret-down",
            "aria-hidden": "true"
          }, null, -1))
        ], 10, _hoisted_12),
        (_ctx.periodOpen)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", {
                class: "crb-backdrop",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.periodOpen = false))
              }),
              _createVNode(_component_DateRangePopover, {
                "model-value": _ctx.filters.range,
                preset: _ctx.filters.preset,
                onApply: _ctx.applyPeriod,
                onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.periodOpen = false))
              }, null, 8, ["model-value", "preset", "onApply"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isRib)
        ? _withDirectives((_openBlock(), _createElementBlock("select", {
            key: 0,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.bank) = $event)),
            class: "form-select crb-select",
            "aria-label": "Banque",
            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fetchData(1)))
          }, [
            _cache[32] || (_cache[32] = _createElementVNode("option", { value: "" }, "Toutes les banques", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banks, (b) => {
              return (_openBlock(), _createElementBlock("option", {
                key: b.id,
                value: String(b.id)
              }, _toDisplayString(b.name), 9, _hoisted_13))
            }), 128))
          ], 544)), [
            [_vModelSelect, _ctx.filters.bank]
          ])
        : _createCommentVNode("", true),
      (_ctx.hasFilters)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "crb-reset",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
          }, _cache[33] || (_cache[33] = [
            _createElementVNode("i", {
              class: "ph ph-x",
              "aria-hidden": "true"
            }, null, -1),
            _createTextVNode("Réinitialiser ", -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", {
      class: "crb-list",
      "aria-busy": _ctx.loading
    }, [
      (_ctx.loading && !_ctx.rows.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(4, (n) => {
            return _createElementVNode("span", {
              key: n,
              class: "crb-skel"
            })
          }), 64))
        : (_ctx.loadError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _cache[34] || (_cache[34] = _createElementVNode("i", {
                class: "ph ph-warning-circle",
                "aria-hidden": "true"
              }, null, -1)),
              _cache[35] || (_cache[35] = _createElementVNode("p", null, "Impossible de charger les demandes.", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-light",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.fetchData(_ctx.pager.current_page)))
              }, "Réessayer")
            ]))
          : (!_ctx.rows.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("i", {
                  class: _normalizeClass(["ph", _ctx.filters.statut === '0' ? 'ph-check-circle' : 'ph-tray']),
                  "aria-hidden": "true"
                }, null, 2),
                _createElementVNode("p", null, _toDisplayString(_ctx.filters.statut === "0" && !_ctx.hasFilters ? "Aucune demande en attente. Tout est traité 🎉" : "Aucune demande ne correspond aux filtres."), 1)
              ]))
            : (_openBlock(), _createElementBlock("ul", {
                key: 3,
                class: _normalizeClass(["crb-rows", { 'is-refreshing': _ctx.loading }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: row.id
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["crb-row", { 'is-selected': _ctx.selected && _ctx.selected.id === row.id }]),
                      onClick: ($event: any) => (_ctx.openReview(row))
                    }, [
                      _createElementVNode("span", _hoisted_18, [
                        (row.client?.logo)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: row.client.logo,
                              alt: "",
                              referrerpolicy: "no-referrer",
                              onError: _cache[9] || (_cache[9] = ($event: any) => (($event.target as HTMLImageElement).remove()))
                            }, null, 40, _hoisted_19))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, _toDisplayString(_ctx.initials(row.customer_name || row.client?.name)), 1)
                      ]),
                      _createElementVNode("span", _hoisted_20, [
                        _createElementVNode("strong", null, _toDisplayString(row.customer_name || row.client?.name || "Client #" + row.customer), 1),
                        _createElementVNode("small", null, [
                          _cache[36] || (_cache[36] = _createElementVNode("i", {
                            class: "ph ph-storefront",
                            "aria-hidden": "true"
                          }, null, -1)),
                          _createTextVNode(_toDisplayString(row.magasin?.name || "Magasin #" + row.magasin_id), 1)
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_21, [
                        _createElementVNode("span", {
                          class: "crb-old",
                          title: 'Actuel : ' + _ctx.display(row.old_rib)
                        }, _toDisplayString(_ctx.display(row.old_rib) || "—"), 9, _hoisted_22),
                        _cache[37] || (_cache[37] = _createElementVNode("i", {
                          class: "ph ph-arrow-right",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.display(row.new_rib)), 1),
                        (_ctx.isRib && row.bank_name)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_24, _toDisplayString(row.bank_name), 1))
                          : _createCommentVNode("", true),
                        (_ctx.isRib && row.account_holder)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_25, _toDisplayString(row.account_holder), 1))
                          : _createCommentVNode("", true),
                        (!_ctx.isRib)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_26, _toDisplayString(_ctx.phoneKindLabel(row)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.isRib)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "crb-docs",
                            "aria-label": _ctx.docsSummary(row)
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docKinds, (d) => {
                              return (_openBlock(), _createElementBlock("i", {
                                key: d.key,
                                class: _normalizeClass(["ph", [d.icon, row.has_docs?.[d.key] ? 'is-on' : 'is-off']]),
                                title: d.label + (row.has_docs?.[d.key] ? ' fourni' : ' manquant'),
                                "aria-hidden": "true"
                              }, null, 10, _hoisted_28))
                            }), 128))
                          ], 8, _hoisted_27))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_29, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["crb-status", 'st-' + row.statut])
                        }, _toDisplayString(_ctx.statusLabel(row.statut)), 3),
                        _createElementVNode("small", {
                          class: _normalizeClass({ 'is-late': _ctx.isLate(row) }),
                          title: _ctx.fullDate(row.created_at)
                        }, _toDisplayString(_ctx.ago(row.created_at)), 11, _hoisted_30)
                      ]),
                      _cache[38] || (_cache[38] = _createElementVNode("i", {
                        class: "ph ph-caret-right crb-go",
                        "aria-hidden": "true"
                      }, null, -1))
                    ], 10, _hoisted_17)
                  ]))
                }), 128))
              ], 2)),
      (_ctx.pager.last_page > 1)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_31, [
            _createElementVNode("button", {
              type: "button",
              disabled: _ctx.pager.current_page <= 1,
              "aria-label": "Page précédente",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.fetchData(_ctx.pager.current_page - 1)))
            }, _cache[39] || (_cache[39] = [
              _createElementVNode("i", {
                class: "ph ph-caret-left",
                "aria-hidden": "true"
              }, null, -1)
            ]), 8, _hoisted_32),
            _createElementVNode("span", null, [
              _cache[40] || (_cache[40] = _createTextVNode("Page ", -1)),
              _createElementVNode("b", null, _toDisplayString(_ctx.pager.current_page), 1),
              _createTextVNode(" / " + _toDisplayString(_ctx.pager.last_page) + " · " + _toDisplayString(_ctx.pager.total) + " demande(s)", 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              disabled: _ctx.pager.current_page >= _ctx.pager.last_page,
              "aria-label": "Page suivante",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.fetchData(_ctx.pager.current_page + 1)))
            }, _cache[41] || (_cache[41] = [
              _createElementVNode("i", {
                class: "ph ph-caret-right",
                "aria-hidden": "true"
              }, null, -1)
            ]), 8, _hoisted_33)
          ]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_14),
    _createVNode(_Transition, { name: "crb-fade" }, {
      default: _withCtx(() => [
        (_ctx.selected)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "crb-scrim",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeReview && _ctx.closeReview(...args)))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "crb-slide" }, {
      default: _withCtx(() => [
        (_ctx.selected)
          ? (_openBlock(), _createElementBlock("aside", {
              key: 0,
              ref: "drawerEl",
              class: "crb-drawer",
              role: "dialog",
              "aria-modal": "true",
              "aria-labelledby": "crb-drawer-title",
              tabindex: "-1",
              onKeydown: _cache[25] || (_cache[25] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeReview && _ctx.closeReview(...args)), ["esc"]))
            }, [
              _createElementVNode("header", _hoisted_34, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["crb-status", 'st-' + _ctx.selected.statut])
                  }, _toDisplayString(_ctx.statusLabel(_ctx.selected.statut)), 3),
                  _createElementVNode("h2", _hoisted_35, _toDisplayString(_ctx.selected.customer_name || _ctx.selected.client?.name), 1),
                  _createElementVNode("p", null, [
                    _cache[42] || (_cache[42] = _createElementVNode("i", {
                      class: "ph ph-storefront",
                      "aria-hidden": "true"
                    }, null, -1)),
                    _createTextVNode(_toDisplayString(_ctx.selected.magasin?.name || "Magasin #" + _ctx.selected.magasin_id) + " ", 1),
                    _cache[43] || (_cache[43] = _createElementVNode("span", { "aria-hidden": "true" }, "·", -1)),
                    _createTextVNode(" Demande #" + _toDisplayString(_ctx.selected.id) + " du " + _toDisplayString(_ctx.fullDate(_ctx.selected.created_at)), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "crb-x",
                  "aria-label": "Fermer",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closeReview && _ctx.closeReview(...args)))
                }, _cache[44] || (_cache[44] = [
                  _createElementVNode("i", {
                    class: "ph ph-x",
                    "aria-hidden": "true"
                  }, null, -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("section", _hoisted_37, [
                  _cache[54] || (_cache[54] = _createElementVNode("h3", null, "Changement demandé", -1)),
                  (!_ctx.isRib)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_38, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["ph", _ctx.isPersonal(_ctx.selected) ? 'ph-user' : 'ph-briefcase']),
                          "aria-hidden": "true"
                        }, null, 2),
                        _createElementVNode("span", null, [
                          _cache[45] || (_cache[45] = _createTextVNode("Type de numéro à modifier : ", -1)),
                          _createElementVNode("b", null, _toDisplayString(_ctx.isPersonal(_ctx.selected) ? "Personnel" : "Professionnel"), 1)
                        ])
                      ]))
                    : (_ctx.selected.account_holder)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_39, [
                          _cache[47] || (_cache[47] = _createElementVNode("i", {
                            class: "ph ph-user",
                            "aria-hidden": "true"
                          }, null, -1)),
                          _createElementVNode("span", null, [
                            _cache[46] || (_cache[46] = _createTextVNode("Titulaire du compte : ", -1)),
                            _createElementVNode("b", null, _toDisplayString(_ctx.selected.account_holder), 1)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_40, _cache[48] || (_cache[48] = [
                          _createElementVNode("i", {
                            class: "ph ph-warning",
                            "aria-hidden": "true"
                          }, null, -1),
                          _createTextVNode("Titulaire du compte non renseigné.", -1)
                        ]))),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", null, [
                      _cache[49] || (_cache[49] = _createElementVNode("span", null, "Actuel", -1)),
                      _createElementVNode("code", null, _toDisplayString(_ctx.display(_ctx.currentValue(_ctx.selected)) || "—"), 1),
                      (_ctx.isRib && _ctx.selected.magasin?.bank)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_42, _toDisplayString(_ctx.selected.magasin.bank), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[52] || (_cache[52] = _createElementVNode("i", {
                      class: "ph ph-arrow-down",
                      "aria-hidden": "true"
                    }, null, -1)),
                    _createElementVNode("div", _hoisted_43, [
                      _cache[51] || (_cache[51] = _createElementVNode("span", null, "Nouveau", -1)),
                      _createElementVNode("code", null, _toDisplayString(_ctx.display(_ctx.selected.new_rib)), 1),
                      (_ctx.isRib)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_44, _toDisplayString(_ctx.selected.bank_name), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        class: "crb-copy",
                        "aria-label": 'Copier ' + (_ctx.isRib ? 'le RIB' : 'le numéro'),
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.copy(_ctx.selected.new_rib)))
                      }, _cache[50] || (_cache[50] = [
                        _createElementVNode("i", {
                          class: "ph ph-copy",
                          "aria-hidden": "true"
                        }, null, -1)
                      ]), 8, _hoisted_45)
                    ])
                  ]),
                  (_ctx.selected.raison)
                    ? (_openBlock(), _createElementBlock("blockquote", _hoisted_46, [
                        _cache[53] || (_cache[53] = _createElementVNode("i", {
                          class: "ph ph-quotes",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.selected.raison), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("section", _hoisted_47, [
                  _cache[55] || (_cache[55] = _createElementVNode("h3", null, "Contrôles", -1)),
                  _createElementVNode("ul", _hoisted_48, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checks, (c) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: c.label,
                        class: _normalizeClass('is-' + c.state)
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["ph", c.state === 'ok' ? 'ph-check-circle' : c.state === 'warn' ? 'ph-warning' : 'ph-x-circle']),
                          "aria-hidden": "true"
                        }, null, 2),
                        _createElementVNode("span", null, _toDisplayString(c.label), 1)
                      ], 2))
                    }), 128))
                  ])
                ]),
                (_ctx.isRib)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_49, [
                      _cache[58] || (_cache[58] = _createElementVNode("h3", null, "Justificatifs", -1)),
                      (!_ctx.docsEnabled)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_50, _cache[56] || (_cache[56] = [
                            _createElementVNode("i", {
                              class: "ph ph-plug",
                              "aria-hidden": "true"
                            }, null, -1),
                            _createTextVNode("Consultation indisponible : la clé REQUEST_DOCS_KEY n'est pas configurée sur le serveur. ", -1)
                          ])))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_51, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docKinds, (d) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: d.key,
                            class: _normalizeClass(["crb-doc", { 'is-missing': !_ctx.selected.has_docs?.[d.key] }])
                          }, [
                            (_ctx.selected.has_docs?.[d.key] && _ctx.selected.docs?.[d.key])
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "crb-doc-open",
                                  "aria-label": 'Ouvrir ' + d.label,
                                  onClick: ($event: any) => (_ctx.openDoc(d.key))
                                }, [
                                  (!_ctx.docFailed[d.key])
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _ctx.selected.docs[d.key],
                                        alt: d.label,
                                        referrerpolicy: "no-referrer",
                                        loading: "lazy",
                                        onError: ($event: any) => (_ctx.docFailed[d.key] = true)
                                      }, null, 40, _hoisted_53))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_54, _cache[57] || (_cache[57] = [
                                        _createElementVNode("i", {
                                          class: "ph ph-file-pdf",
                                          "aria-hidden": "true"
                                        }, null, -1),
                                        _createTextVNode("Ouvrir", -1)
                                      ])))
                                ], 8, _hoisted_52))
                              : (_openBlock(), _createElementBlock("span", _hoisted_55, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["ph", d.icon]),
                                    "aria-hidden": "true"
                                  }, null, 2),
                                  _createTextVNode(_toDisplayString(_ctx.selected.has_docs?.[d.key] ? "Indisponible" : "Non fourni"), 1)
                                ])),
                            _createElementVNode("small", null, _toDisplayString(d.label), 1)
                          ], 2))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (Number(_ctx.selected.statut) === 0)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_56, [
                      _cache[63] || (_cache[63] = _createElementVNode("h3", null, "Décision", -1)),
                      _createElementVNode("details", {
                        class: "crb-fix",
                        open: _ctx.fixOpen,
                        onToggle: _cache[18] || (_cache[18] = ($event: any) => (_ctx.fixOpen = ($event.target as HTMLDetailsElement).open))
                      }, [
                        _cache[62] || (_cache[62] = _createElementVNode("summary", null, [
                          _createElementVNode("i", {
                            class: "ph ph-pencil-simple",
                            "aria-hidden": "true"
                          }),
                          _createTextVNode("Corriger avant de valider")
                        ], -1)),
                        (_ctx.isRib)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                              _createElementVNode("label", null, [
                                _cache[59] || (_cache[59] = _createElementVNode("span", null, "RIB (24 chiffres)", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.fix.rib) = $event)),
                                  type: "text",
                                  inputmode: "numeric",
                                  class: "form-control crb-mono",
                                  maxlength: "32",
                                  placeholder: _ctx.selected.new_rib
                                }, null, 8, _hoisted_59), [
                                  [_vModelText, _ctx.fix.rib]
                                ])
                              ]),
                              _createElementVNode("label", null, [
                                _cache[60] || (_cache[60] = _createElementVNode("span", null, "Banque", -1)),
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.fix.bank_id) = $event)),
                                  class: "form-select"
                                }, [
                                  _createElementVNode("option", _hoisted_60, _toDisplayString(_ctx.selected.bank_name || "—") + " (demandée)", 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banks, (b) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: b.id,
                                      value: String(b.id)
                                    }, _toDisplayString(b.name) + _toDisplayString(b.code ? " · " + b.code : ""), 9, _hoisted_61))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.fix.bank_id]
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("label", _hoisted_62, [
                              _cache[61] || (_cache[61] = _createElementVNode("span", null, "Numéro", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.fix.phone) = $event)),
                                type: "tel",
                                class: "form-control crb-mono",
                                maxlength: "20",
                                placeholder: _ctx.display(_ctx.selected.new_rib)
                              }, null, 8, _hoisted_63), [
                                [_vModelText, _ctx.fix.phone]
                              ])
                            ]))
                      ], 40, _hoisted_57),
                      _createElementVNode("label", _hoisted_64, [
                        _createTextVNode(_toDisplayString(_ctx.mode === "refuse" ? "Motif du refus (visible par le client)" : "Commentaire (facultatif, visible par le client)") + " ", 1),
                        (_ctx.mode === 'refuse')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_65, "*"))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.mode === 'refuse')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quickReasons, (q) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: q,
                                type: "button",
                                onClick: ($event: any) => (_ctx.note = q)
                              }, _toDisplayString(q), 9, _hoisted_67))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("textarea", {
                        id: "crb-note",
                        ref: "noteEl",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.note) = $event)),
                        class: _normalizeClass(["form-control", { 'is-invalid': _ctx.noteError }]),
                        rows: "3",
                        maxlength: "500",
                        onInput: _cache[20] || (_cache[20] = ($event: any) => (_ctx.noteError = ''))
                      }, null, 34), [
                        [_vModelText, _ctx.note]
                      ]),
                      (_ctx.noteError)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.noteError), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.note.length) + "/500", 1)
                    ]))
                  : (_openBlock(), _createElementBlock("section", _hoisted_70, [
                      _cache[65] || (_cache[65] = _createElementVNode("h3", null, "Décision", -1)),
                      _createElementVNode("p", {
                        class: _normalizeClass(["crb-note", Number(_ctx.selected.statut) === 1 ? 'is-ok' : 'is-bad'])
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["ph", Number(_ctx.selected.statut) === 1 ? 'ph-seal-check' : 'ph-prohibit']),
                          "aria-hidden": "true"
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(Number(_ctx.selected.statut) === 1 ? "Validée" : "Refusée") + " le " + _toDisplayString(_ctx.fullDate(_ctx.selected.updated_at)), 1)
                      ], 2),
                      (_ctx.selected.statut_note)
                        ? (_openBlock(), _createElementBlock("blockquote", _hoisted_71, [
                            _cache[64] || (_cache[64] = _createElementVNode("i", {
                              class: "ph ph-chat-text",
                              "aria-hidden": "true"
                            }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.selected.statut_note), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ]),
              (Number(_ctx.selected.statut) === 0)
                ? (_openBlock(), _createElementBlock("footer", _hoisted_72, [
                    (_ctx.mode === 'refuse')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-light",
                            disabled: _ctx.busy,
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.mode = 'approve'))
                          }, "Annuler", 8, _hoisted_73),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger",
                            disabled: _ctx.busy,
                            onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.refuse && _ctx.refuse(...args)))
                          }, [
                            (_ctx.busy)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_75))
                              : _createCommentVNode("", true),
                            _cache[66] || (_cache[66] = _createTextVNode(" Confirmer le refus ", -1))
                          ], 8, _hoisted_74)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline-danger",
                            disabled: _ctx.busy,
                            onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.startRefuse && _ctx.startRefuse(...args)))
                          }, _cache[67] || (_cache[67] = [
                            _createElementVNode("i", {
                              class: "ph ph-x",
                              "aria-hidden": "true"
                            }, null, -1),
                            _createTextVNode("Refuser ", -1)
                          ]), 8, _hoisted_76),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary",
                            disabled: _ctx.busy || _ctx.hasBlockingCheck,
                            onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.approve && _ctx.approve(...args)))
                          }, [
                            (_ctx.busy)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_78))
                              : (_openBlock(), _createElementBlock("i", _hoisted_79)),
                            _cache[68] || (_cache[68] = _createTextVNode("Valider le changement ", -1))
                          ], 8, _hoisted_77)
                        ], 64))
                  ]))
                : _createCommentVNode("", true)
            ], 544))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}